import Recommend from '../components/recommendpage/Recommend';

const RecommendPage = () => {
    return (
        <>
            <Recommend />
        </>
    );
};

export default RecommendPage;
